var Border = /** @class */ (function () {
    function Border(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'left,top,right,bottom,color,width';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Border.prototype.toJSON = function () {
        return {
            "left": this.left,
            "top": this.top,
            "right": this.right,
            "bottom": this.bottom,
            "all": this.all,
            "color": this.color,
            "width": this.width
        };
    };
    Border.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Border;
}());
export { Border };
//# sourceMappingURL=border.js.map